import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65772145"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row mb-3 mx-lg-5 mx-2 border-bottom mt-3"
}
const _hoisted_2 = { class: "d-flex mb-2 mb-lg-2 fs-17 name-point" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "text-green fw-bold" }
const _hoisted_5 = { class: "fs-75 =" }
const _hoisted_6 = { class: "col-lg-3 d-flex justify-content-center mb-3" }
const _hoisted_7 = {
  key: 2,
  class: "text-center fw-bold pt-4"
}

import dayjs from 'dayjs'
import { useStore } from 'vuex'
import { onMounted, ref, watch, computed } from 'vue'
import { translate } from '@/languages/i18n'
import { POINT_STORE, ROOT_STORE } from '@/store/constants'
import { numberWithCommas } from '@/constants/common.ts'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  source: {
    type: Object,
    default: null,
  },
  index: Number,
},
  setup(__props) {

const props = __props


const store = useStore()
// const route = useRoute()
const exchangeHistory = computed(() => store.getters[POINT_STORE.GETTERS.EXCHANGE_HISTORIES])

const last_item_history = ref<HTMLElement>()
const observer = ref()
const page = computed(() => store.getters[POINT_STORE.GETTERS.PAGE_EXCHANGE])
const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const getDataExchange = (page: number) => {
  store.dispatch(POINT_STORE.ACTIONS.SET_EXCHANGE_HISTORIES, { params: { ...(page && { page }) } })
}

onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (page.value >= exchangeHistory.value.total_pages) return
      store.dispatch(POINT_STORE.ACTIONS.SET_PAGE_EXCHANGE)
      if (page.value !== 1) getDataExchange(page.value)
    }
  })
  if (last_item_history.value) {
    observer?.value?.observe(last_item_history.value)
  }
})
watch(
  () => last_item_history.value,
  () => {
    if (last_item_history.value) {
      observer?.value?.observe(last_item_history.value)
    }
  }
)

const transitGiftpad = () => {
  window.open(props.source.giftpad_url, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.source?.point !== 'last_item_history_to_scroll')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass([!_unref(isMobile) ? 'point-info' : '', 'col-lg-8'])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)('SJ10exchangePoints')), 1),
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(numberWithCommas)(__props.source?.point).substring(1)) + "pt", 1)
            ]),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(translate)('SJ10dateExchange')) + "： " + _toDisplayString(_unref(dayjs)(__props.source?.created_at).format('YYYY年M月D日')), 1)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(Button, {
              title: _unref(translate)('SJ10exchange'),
              type: 'secondary',
              size: 'small',
              class: _normalizeClass('fw-bold'),
              onClick: transitGiftpad
            }, null, 8, ["title"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref: (_value, _refs) => {
            _refs['last_item_history'] = _value
            last_item_history.value = _value
          }
        }, null, 512)),
    (_unref(exchangeHistory).data?.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(translate)('CC10noData')), 1))
      : _createCommentVNode("", true)
  ], 64))
}
}

})